import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { getExclusiveOffer } from 'store/exclusiveOffer/exclusiveOfferSelectors';
import { Box, Flex, Heading, Wrapper } from '@qga/roo-ui/components';
import PropertyFacilities from 'components/PropertyPage/PropertyFacilities';
import { useBreakpoints } from 'hooks/useBreakpoints';
import ExclusiveOfferConditions from 'components/PropertyPage/ExclusiveOfferConditions';
import ExclusiveInclusions from '../ExclusiveInclusions';

const FacilitiesWrapper = styled(Flex)`
  flex-grow: 1;
`;

const PropertySummaryFacilities = ({ property, hasPropertyFacilities }) => {
  const exclusiveOffer = useSelector(getExclusiveOffer);
  const { isLessThanBreakpoint } = useBreakpoints();
  const isMobile = isLessThanBreakpoint(1);
  const hasExclusiveInclusions = !!exclusiveOffer?.highlights?.inclusions?.length;

  return (
    <Wrapper
      pl={[6, 3, 0]}
      borderTop={!exclusiveOffer && isMobile ? [1, 0, 0] : !exclusiveOffer ? [1, 0, 0] : 0}
      pt={!exclusiveOffer ? [4, 0, 0] : 0}
      borderColor={'greys.alto'}
      width={exclusiveOffer ? ['350px', 'auto'] : 'auto'}
    >
      <Flex flex="1 1 auto" flexDirection={['column', 'column', 'row']} mb={exclusiveOffer ? [0, 0, 15] : [0, 4, 6]}>
        <FacilitiesWrapper borderBottom={[(1, 0, 0)]} borderColor="greys.alto" flexDirection="column" justifyContent="space-between">
          {exclusiveOffer && (
            <>
              <Box borderTop={exclusiveOffer ? 0 : [1, 0, 0]} borderColor={'greys.alto'}>
                <Heading.h2
                  color="greys.charcoal"
                  fontWeight={exclusiveOffer ? ['normal', 'bold', 'normal'] : ['bold', 'bold', 'normal']}
                  fontSize={exclusiveOffer ? ['md', 'base', '22px'] : ['base', 'base', 'lg']}
                  pt={exclusiveOffer ? [4, 0, 4] : 0}
                >
                  {'Exclusive inclusions:'}
                </Heading.h2>
                {hasExclusiveInclusions && <ExclusiveInclusions inclusions={exclusiveOffer?.highlights?.inclusions} />}
              </Box>
            </>
          )}
          {hasPropertyFacilities && !exclusiveOffer && (
            <Box>
              <Heading.h2
                color="greys.charcoal"
                fontWeight={['bold', 'bold', 'normal']}
                fontSize={['base', 'base', 'lg']}
                data-testid="facilities-heading"
                marginBottom={0}
              >
                Most popular facilities
              </Heading.h2>
              <PropertyFacilities facilities={property.propertyFacilities} summary={isMobile} interactionEventValue="Top Link Selected" />
            </Box>
          )}
          {exclusiveOffer && <ExclusiveOfferConditions />}
        </FacilitiesWrapper>
      </Flex>
    </Wrapper>
  );
};

PropertySummaryFacilities.propTypes = {
  property: PropTypes.object.isRequired,
  hasPropertyFacilities: PropTypes.bool.isRequired,
};

export default PropertySummaryFacilities;
